export const isSafari = () =>
  typeof window !== "undefined" &&
  (/constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(!window.safari || (typeof safari !== "undefined" && window.safari.pushNotification)));

export const isIOS = () =>
  typeof window !== "undefined" &&
  (["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
    window.navigator.platform
  ) ||
    (window.navigator.userAgent.includes("Mac") && "ontouchend" in window.document));

export const isBrave = () => {
  return typeof window !== "undefined" && window?.navigator?.brave;
};
